// Typelizer digest b760a66e5c40f3e75a5aa0459aa2efb8
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** PATCH /current_account */
  update: (options?: RouteOptions): RouteDefinition<'patch'> => ({
    url: buildUrl('/current_account', {}, options),
    method: 'patch',
  }),
}
